var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrustly(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 478.2 101.1",
    style: {
      enableBackground: "new 0 0 478.2 101.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#0EE06E;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M159.2,80.3V15h-23.6V0.7h62.6V15h-23.6v65.3H159.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M196.5,80.3V22.5h14.4v9.1c3.7-7.8,8.4-9.1,13.4-9.1h5.7V37h-4.9c-7.3,0-13.7,4.2-13.7,17v26.3H196.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M238.1,59.4V22.5H253v33.4c0,7.4,3.8,12.3,10.6,12.3c6.6,0,11.3-4.9,11.3-12.2V22.6h14.8v57.8h-14.3v-7.3 c-3.7,5.8-9.5,8.6-16.7,8.6C246.5,81.6,238.1,73.4,238.1,59.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M297.5,64l13.1-3c0.6,5.1,4.8,8.5,11.7,8.5c5.7,0,9-2.4,9-5.5c0-2.5-1.5-4.2-7-5.5l-9.4-2.2 c-11-2.5-16.1-7.8-16.1-17.3c0-9.8,8.2-17.6,23.1-17.6c15.8,0,22.4,9.4,23.3,16.1l-13.1,2.8c-0.6-3.6-3.4-7.4-10.5-7.4 c-4.7,0-8.2,2.2-8.2,5.2c0,2.7,2.1,4.2,5.2,5.1l12.7,3c9.9,2.4,14.8,8.2,14.8,16.7c0,9.3-7.5,18.4-23.7,18.4 C304.8,81.4,298.3,71,297.5,64z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M376.5,80.3c-9.9,0-16.3-5.7-16.3-16.3V35.3h-9.6V22.5h9.6V9.3L375.1,5v17.5h11.8v12.8h-11.8v26.1 c0,4.2,2.1,5.9,6.3,5.9h6.4v12.8h-11.3V80.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M397.5,80.3V0.7h14.8v79.6H397.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M461.3,22.5h16L452.8,101h-16l6.7-20.7h-8.1l-16.4-57.8h16L447.5,68L461.3,22.5z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "0,35.6 37.1,35.6 37.1,5.9 66.7,35.6 37.1,65.2 37.1,80.3 73,80.3 73,35.6 106.1,35.6 106.1,0.7  0,0.7  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrustly);
export default __webpack_public_path__ + "static/media/trustly.0858d1b3f0d5142d24e2f986c9ce5195.svg";
export { ForwardRef as ReactComponent };